import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks/reduxHooks';
import { handleLogout } from '../utils/sessionManager';

export const SuspendedPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Handle logout and redirect to login
  const handleLogoutClick = () => {
    handleLogout(dispatch);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-10 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <h1 className="text-4xl font-gilroy-bold text-red-600 mb-2">Account Suspended</h1>
          <p className="text-xl font-gilroy-medium text-gray-700 mb-8">
            Your account has been suspended by the administrator.
          </p>
          <p className="text-brand-gray mb-8">
            Please contact your administrator for more information.
          </p>
          
          <div className="flex flex-col space-y-4">
            <button
              onClick={handleLogoutClick}
              className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 shadow-sm text-sm font-gilroy-medium rounded-md text-red-600 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 